import Pill from 'components/Pill/Pill';

export default Pill;
